import React from "react"
import autobind from "class-autobind"
import ImageLoader from "../../../components/misc/ImageLoader"
import Paper from "material-ui/Paper"
import { amber500 } from "material-ui/styles/colors"
import { IFaceSpace } from "../../../models"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"

interface IProps {
    selected: boolean
    faceSpace: IFaceSpace
    onSelectedStateChange(): void
    onDelete(): void
    onSetProfilePic(): void
}
interface IState {
    isHovering: boolean
}

export default class UserDetailsFaceSpaceTile extends React.Component<IProps, IState> {
    private editProfilePic: boolean
    private editFaceSpaces: boolean
    private readonly: boolean
    constructor(props: IProps) {
        super(props)
        this.editProfilePic = permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditProfilePic)
        this.editFaceSpaces = permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditFaceSpaces)
        this.readonly = !this.editProfilePic && !this.editFaceSpaces
        this.state = {
            isHovering: false
        }
        autobind(this)
    }

    handleMouseOver() {
        this.setState({ isHovering: true })
    }

    handleMouseOut() {
        this.setState({ isHovering: false })
    }

    render() {
        const isActive = this.state.isHovering || this.props.selected
        const checkDisplay = this.props.selected
        const opacityOverlay = isActive ? 0.3 : 0
        const opacityCircle = isActive ? 1 : 0
        return (
            <div className="UserDetailsFaceSpaceTile">
                <Paper zDepth={2} style={{ position: "relative" }}>
                    <ImageLoader url={this.props.faceSpace.ImageS3Url} fixedHeight={300} src={"/users/profileimage/" + this.props.faceSpace.ImageID} />
                    <div
                        style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%"
                        }}
                    >
                        <div
                            style={{
                                position: "relative",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                background: amber500,
                                opacity: opacityOverlay,
                                cursor: this.readonly ? "" : "pointer"
                            }}
                            onClick={() => this.editFaceSpaces &&
                                this.props.onSelectedStateChange()
                            }
                            onMouseOver={this.handleMouseOver}
                            onMouseOut={this.handleMouseOut}
                        />
                        {this.editFaceSpaces &&
                            <span
                                className="fa-stack fa-lg"
                                style={{
                                    position: "absolute",
                                    top: 3,
                                    display: "block",
                                    padding: 5,
                                    cursor: "pointer",
                                    opacity: opacityCircle
                                }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                                onClick={this.props.onSelectedStateChange}
                            >
                                <i className="fa fa-circle fa-stack-2x" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} style={{ cursor: "pointer", color: "#333333" }} />
                                {checkDisplay && (
                                    <i
                                        className="fa fa-check fa-stack-1x fa-inverse"
                                        onMouseOver={this.handleMouseOver}
                                        onMouseOut={this.handleMouseOut}
                                        style={{
                                            cursor: "pointer",
                                            display: "inline-block"
                                        }}
                                    />
                                )}
                            </span>
                        }
                        {this.editProfilePic &&
                            <div
                                style={{
                                    color: "#ffffff",
                                    position: "absolute",
                                    right: this.editFaceSpaces ? 30 : 0,
                                    top: 0,
                                    padding: 10,
                                    display: isActive,
                                    fontSize: 22,
                                    cursor: "pointer"
                                }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                                onClick={this.props.onSetProfilePic}
                            >
                                <i className="fa fa-user" />
                            </div>
                        }
                        {this.editFaceSpaces &&
                            <div
                                data-intercom-target={"menu-Employees-FaceSpaces-Btn-DeleteFaceSpacePic"}
                                style={{
                                    color: "#ffffff",
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    padding: 10,
                                    display: isActive,
                                    fontSize: 22,
                                    cursor: "pointer"
                                }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                                onClick={this.props.onDelete}
                            >
                                <i className="fa fa-trash" />
                            </div>
                        }
                    </div>
                </Paper>
            </div>
        )
    }
}